/* eslint-disable semi,semi-style */
import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import Header, { UserInfoContext } from '../developer/components/header';
import 'antd/dist/antd.css';
import './index.scss';
import { getUserInfoInDirect } from './service';
import { login, resumeAfterLogin } from '@/util/login'
import HomePage from './HomePage';
class APP extends React.Component {
  state = {
    user: null,
  }
  doLogin = () => {
    location.href = login()
  }

  handleClick = () => {
    if (!this.state.user) {
      console.log('未登录')
      this.doLogin()
      return;
    }
    console.log('已登录');

    location.href = '/developer.html#/direct/directApply';
    // developer.html
  }
  componentDidMount() {
    // Omega.trackEvent('am_b_open_index_sw', '能源开放平台-首页', {
    //   host: location.hostname,
    // });
    getUserInfoInDirect().then(res => {
      this.setState({
        user: res,
      });
      resumeAfterLogin();
    });
    document.getElementById('attach-link-up').addEventListener('click', this.handleClick)
    document.getElementById('attach-link-down').addEventListener('click', this.handleClick)
  }
  render() {
    const { user } = this.state;
    return (
      <UserInfoContext.Provider value={user}>
        <Router>
          <Header user={user} className="homepage-header" />
          <HomePage user={user} />
        </Router>
      </UserInfoContext.Provider>
    );
  }
}

export default APP
